export default defineNuxtPlugin(() => {
  if (useCookie('access_token').value) {
    localStorage.setItem(
      'access_token',
      useCookie('access_token').value as string
    )
  }
  if (useCookie('guest_id').value) {
    localStorage.setItem(
      'guest_id_snapshot',
      useCookie('guest_id').value as string
    )
  }
  if (useCookie('login_info').value) {
    localStorage.setItem(
      'login_info',
      JSON.stringify(useCookie('login_info').value)
    )
  }
})
